import { LoadingStage } from "src/Interfaces/shared";

export * from "./filter";
export * from "./zIndex";

export const SPACE_TOKEN = "/=";
export const PAGINATION = 16;
export const BOOKING_SYSTEM = "CMS";
export const BOOKING_SYSTEMS = ["CMS", "Generic", "Respaxv2", "Clockwork", "IBIS"];
// booking systems that passes their
export const BOOKING_SYSTEM_DEFAULT_BOOKING_TIME_ID = "0";
export const BOOKING_SYSTEM_RESPAX_V2 = "respaxv2";
export const BOOKING_SYSTEM_IBIS = "ibis";
export const BOOKING_SYSTEMS_WITH_CUSTOM_BOOKING_TIME_IDS = ["respaxv2", "ibis"];

export const LOADING_STAGES = [LoadingStage.IS_INITIALIZING, LoadingStage.IS_LOADING];

// Date formats
export const BOOKING_DATE_FORMAT = "DD-MMM-YYYY";
export const CHECK_AVAILABILITY_START_DATE_FORMAT = "DD-MMM-YYYY";
export const FARE_PRICE_TRAVEL_DATE_FORMAT = "DD MMM YYYY";

//cart
export const CartConstants = {
    CART: 1,
    CHECKOUT: 2,
    ORDER_SUCCESS: 4,
    PAYMENT: 3,
};
export const BookNowConstants = {
    BOOK_NOW: 1,
    CHECKOUT: 2,
    PURCHASE: 3,
};

// steps
export const CartStepLabels: string[] = ["Cart", "Checkout"];
export const QuoteStepLabels: string[] = ["Items", "Checkout"];
export const BookNowStepLabels: string[] = ["Item", "Checkout"];

export const DEFAULT_RETURN_PATH = "/";
//duration toast message
export const DURATION_TIME = 30000;
/**
 * Apple Service ID for web Sign in with Apple. Comes from REACT_APP_APPLE_CLIENT_ID in the
 * .env.<flavor>.<environment> file; presence is enforced at build time by env.schema.json.
 * Under jest no env file is loaded, so we fall back to "" rather than throwing at import.
 */
export const APPLE_OAUTH_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID ?? "";

// For now, just update the PP background, can have the other use the default
export const LOGIN_BACKGROUND =
    process.env.REACT_APP_FLAVOR === "peterpans"
        ? "/images/peterpans-login-page-background.jpg"
        : "/images/login-background.png";
//payment
export const PAYMENT_OPTION = "Payment";
export const SHARE_OPTION = "Save";
export const CONSTANT_INFORMATION =
    "Global Travel Marketplace Pty Ltd t/as Freelance Travel ABN 37 108 915 594 | 60 Baxter Street, , Fortitude Valley QLD 4509 © 2024 Freelance Travel Powered by Global Travel Marketplace Pty Ltd";
export const CONSTANT_CONTACT = "support@freelancetravel.com";
export const RETURN_TO_PARAM_KEY = "return_to";

/**
 * sessionStorage flag marking that the sign-in prompt has already been offered
 * on this browsing session, so Book Now / Add to Cart don't re-ask. Cleared on
 * logout, so the next visitor on the same browser is offered it again.
 */
export const SIGN_IN_PROMPT_SEEN_KEY = "addToCartSignInPromptSeen";
